import { Injectable } from '@angular/core'
import { EventApi } from './base'

@Injectable()
export class StaticContentEventApi extends EventApi{
  apiPath(resourceId: number, areaId = '') {
    return `static_contents/${resourceId}/events/${areaId}`
  }
}



// WEBPACK FOOTER //
// ./src/apis/event/static-content.ts